import {ReactNode} from "react";
import styled from "styled-components";

interface BreadcrumbProps {
	children: ReactNode;
}

const Wrap = styled.ul`
	display: flex;
	justify-content: end;
	height: 50px;
	align-items: center;

	li {
		position: relative;
		padding-right: 19px;
		margin-right: 15px;
		font-size: var(--basic-size);
		color: var(--gray-color);
		line-height: 1;

		&:after {
			position: absolute;
			top: 5px;
			right: 0;
			display: inline-block;
			width: 5px;
			height: 5px;
			border-top: 1px solid var(--default-color);
			border-left: 1px solid var(--default-color);
			transform: rotate(135deg);
			content: "";
		}

		&:last-child {
			padding-right: 0;
			margin-right: 0;

			&:after {
				display: none;
			}
		}

		a:hover {
			color: var(--emp-color);
			text-decoration: underline;
		}
	}
`;

const Breadcrumbs = ({children}: BreadcrumbProps) => <Wrap>{children}</Wrap>;

export default Breadcrumbs;
